<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="business-body custom-form">
          <div class="tab-box">
            <span class="color526bec">{{driverName}}</span>
            <span>今日：派单 <span class="color526bec">{{ driverInfo.totalOrderNum }}</span></span>
            <span>成交<span class="color526bec">{{ driverInfo.completeNum }}</span></span>
            <span>取消<span class="color526bec">{{ driverInfo.cancelOrderNum }}</span></span>
            <span>净得运费<span class="color526bec">{{ driverInfo.totalFee }}</span></span>
          </div>
          <div class="custom-table-box1">
            <custom-table
              :data="tableData"
              :column="tableColumn"
              :total="tableOptions.total"
              :loading="tableOptions.loading"
              :page="tableOptions.pageNumber"
              :size="tableOptions.pageSize"
              :selection="false"
              @pagination="handleSizeChange">
              <template v-slot:orderStatus="{ row }">
                <span class="common-status status-cancel" v-if="row.orderStatus === 0">已取消</span>
                <span class="common-status status-confirm" v-if="row.orderStatus === 100">已完成</span>
                <span class="common-status status-pending-order" v-if="row.orderStatus === 1">待支付</span>
                <span class="common-status status-confirm" v-if="row.orderStatus === 10">待派单</span>
                <span class="common-status status-in-progress" v-if="row.orderStatus === 20">运输中</span>
              </template>
              <template v-slot:orderNo="{ row }">
              <span class="color526bec" style="cursor: pointer" @click="toOrderDetail(row)">
                {{row.orderNo}}
              </span>
              </template>
                          <template v-slot:orderId="{ row }">
                            <span>
                              {{row.points[0]?.cityName}}{{row.points[0]?.districtName}}
                            </span>
                          </template>
                          <template v-slot:points="{ row }">
                            <span>
                              {{row.points[row.points.length - 1].cityName}}{{row.points[row.points.length - 1].districtName}}
                            </span>
                          </template>
            </custom-table>
          </div>
        </div>
      </template>
    </DialogContainer>
    <orderDetail ref="orderDetail"></orderDetail>
  </div>

</template>

<script>
import orderDetail from "../../../OrderManagement/detail.vue"
import CustomTable from "@/components/CustomTable.vue";
import DialogContainer from "@/components/Dialog.vue";
import { getTodayOrderOverview, getTodayOrderPage } from "../api";
import tableMixin from "@/mixin/tableMixin";
export default {
  name: "Detail",
  mixins: [tableMixin],
  components: {
    CustomTable,
    DialogContainer,
    orderDetail,
  },
  data() {
    return {
      getTableMethod: getTodayOrderPage,
      isImmediatelyGetData: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "70%",
        show: false,
        title: "今日订单",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.driverInfo = {}
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      searchForm: {
        driverId: ""
      },
      tableColumn: [
        {
          label: "订单编号",
          prop: "orderNo",
          scopeStatus: true,
          show: true,
        },
        {
          label: "货物名称",
          prop: "cargoName",
          show: true,
        },
        {
          label: "净得运费",
          prop: "driverFee",
          show: true,
        },
        {
          label: "装货地",
          prop: "orderId",
          scopeStatus: true,
          show: true,
        },
        {
          label: "卸货地",
          prop: "points",
          scopeStatus: true,
          show: true,
        },
        {
          label: "订单状态",
          prop: "orderStatus",
          scopeStatus: true,
          show: true,
        },
        {
          label: "派单时间",
          prop: "dispatchTime",
          show: true,
        },
      ],
      driverInfo: {},
      driverName: ""
    };
  },
  mounted() {},
  methods: {
    toOrderDetail(row) {
      this.$refs.orderDetail.init(row);
    },
    init(driverId, driverName) {
      this.driverName = driverName
      this.searchForm.driverId = driverId
      this.getDriverInfo(driverId)
      this.getTableData()
      this.dialogObj.show = true;
    },
    getDriverInfo(driverId) {
      getTodayOrderOverview(driverId).then((res) => {
        if (res.code === 200) {
          this.driverInfo = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  .tab-box {
    display: flex;
    justify-content: center;
    background-color: #ffffff;
    padding: 0.1rem 0;
    span{
      padding: 0 0.1rem;
      font-size: 0.16rem;
    }
    span:nth-of-type(1){}
  }
  .custom-table-box1 {
    box-sizing: border-box;
    background: #f7f8fb;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;


    ::v-deep .el-table .cell {
      line-height: 0.3rem;
    }
  }
}
</style>
